import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router'
// import { Link } from 'react-router-dom'
// import Header from '../../components/Header';
// import { Formik } from 'formik';
// import fetchData from '../../api/FetchData';
import axios from 'axios'
import {
    Avatar,
    Box, 
    Button,
    Checkbox,
    Fab,
    FormControl,
    FormControlLabel,
    IconButton,
    Input,
    InputAdornment,
    InputBase,
    InputLabel,
    TextField,
    Typography,
    useMediaQuery,Tooltip,
    CircularProgress,
  } from '@mui/material';
  import { Close, Check, Save, Send, Visibility, VisibilityOff } from '@mui/icons-material';
  import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
  import LockResetIcon from '@mui/icons-material/LockReset';
  import { enCrypt, deCrypt, aesEncrypt } from '../../api/enCrypt'
  // import { useSnackbar } from 'notistack';
  // import { useDispatch, useSelector } from 'react-redux'
  // import { getCurrentUser, setUser, setClearUser } from '../../context/userSlice'
  import CloudUploadIcon from '@mui/icons-material/CloudUpload';
  import CloudDoneIcon from '@mui/icons-material/CloudDone';
  import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
  import FolderSharedIcon from '@mui/icons-material/FolderShared';
  import { useUserContext, useUserDispatch } from '../../contexts/UserContext';
  import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid';
  import { ChevronDownIcon, PencilIcon  } from '@heroicons/react/16/solid';
  // import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
  // const curDate = new Date()
  function formatDateTime() {
    const now = new Date();
  
    const year = now.getFullYear(); // Get the year
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
    const day = String(now.getDate()).padStart(2, '0'); // Day of the month
  
    const hours = String(now.getHours()).padStart(2, '0'); // Hours
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Minutes
    const seconds = String(now.getSeconds()).padStart(2, '0'); // Seconds
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

const StockTrans = () => {
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState({type:'', info:''});
  const [dataChenged, setDataChenged] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveloading, setSaveLoading] = useState(false);
  const [prod, setProd] = useState([]);
  const [prodImg, setProdImg] = useState(null);
  // const { enqueueSnackbar } = useSnackbar();
  // const { Users } = useSelector(getCurrentUser);
  const navigate = useNavigate();
  const user = useUserContext();

  // const Conf = JSON.parse(localStorage.getItem("Conf"));
  // const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  // const currentUser = user;
  // console.log(userid)
  // console.log(user);
  const initValuesf = 
    {
      id: '',
      date: formatDateTime(),
      transType:  'IN',
      prodId:'',
      prodName: '',
      qty:  0,
      cuser: user.user?.id,
      uname: user.user?.name,
    }

  const transType = [
    {
      value: 1,
      label: 'IN',
    },
    {
      value: 2,
      label: 'Adj-IN',
    },
    {
      value: 3,
      label: 'OUT',
    },
    {
      value: 4,
      label: 'Adj-OUT',
    },
  ];

  const [valuesf, setValuesf] = useState(initValuesf)

  const apiurl = `${process.env.REACT_APP_API}/products.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`

  // console.log(apiurl)

  const fetchProduct = async () => {
    setLoading(true);
    try {

      const response = await axios.get(`${apiurl}?mode=list`);
        
           const data = response.data;
            //  console.log(data);
            //  console.log(response);

      // if(data.length>0 && Object.keys(data).length !== 0) {
        if(data.message=="OK" && data[0].length>0) {
          // const data = await response.json();
          // console.log(data[0][0]);
          // setUsers(response.data[0]);
          setProd(data[0])
          setLoading(false);
          setErrMsg({type:'info', info:""});
          return data;
    
      }else {
        console.log(response);
        setLoading(false);
        setErrMsg({type:'err', info:'Fetch Product Error!!!'});
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      setErrMsg({type:'err', info:'Fetch Product Error!!!'});
    }
  };

  useEffect(() => {
    
      fetchProduct();  
    
  },[])

  // useEffect(() => {
  //   {!user.isLogin && navigate("/")}

  //   if(productid && productid!=='addnew') {
  //     fetchProduct(productid);  
  //   } else {
  //     setValuesf( initValuesf)
  //   }
  // }, [productid,user])
    
  // console.log(valuesf);
  // console.log(conf)

  //===================== handle ================

  const handleAddnew = () => {
    setLoading(false);
    setSaveSuccess(false);
    setDataChenged(false);
    setValuesf(initValuesf);
  }

  const handleCancel =  async (e) => {
    e.preventDefault();
    setLoading(false);
    setSaveSuccess(false);
    setDataChenged(false);
    setValuesf(initValuesf);
  }
  const handleSave =  async (e) => {
    e.preventDefault();
    setLoading(true);
    // encryptPwd()
   
    updateDB()
    
  }

  const updateDB = async () => {

    const updateProduct = {...valuesf, mode:'addtrans', };
    console.log(updateProduct);
    if(valuesf.qty==="" || valuesf.prodName==="") {
      setErrMsg({type:'err', info:'!!!Please Provide correct data !!!'});
    } else {

      try {

          setTimeout( async () => {
            const result = await axios({
              method: 'post',
              url: `${apiurl}`,
              headers: {
                  'Accept': 'application/json',
                  // 'Content-type': 'application/x-www-form-urlencoded',
                  // 'Content-type': 'application/json; charset=utf-8',
                  'Content-Type': 'multipart/form-data'
              },
              data: JSON.stringify(updateProduct) ,
            });

            // console.log(result)
            if (result.data?.success) {
              setLoading(false);
              setSaveSuccess(false);
              setDataChenged(false);
              setValuesf(initValuesf);
              setErrMsg({type:'info', info: result.data?.success});

            } else
            {
              console.log(result);
              setLoading(false);
              setSaveSuccess(false);
              setErrMsg({type:'err', info:'!!! Save Error !!!'});
              // enqueueSnackbar('!!!Save Error !!!', {variant:'error'});
            }

         }, 1500);
        
      } 
      catch (error) {
        // setValuesf({
        //       ...valuesf,
        //       userPwd: '',
        //     });    
        // enqueueSnackbar('!!! Critical Error !!!', {variant:'error'});
          setErrMsg({type:'err', info:'!!! Critical Error !!!'});
          setLoading(false);
          setSaveSuccess(false);
          console.log(error);

          // console.log('handleSave')
      };
    };

  }

  const  handleFormChange = (prop) => async (event) => {
  
    // }
    
    // Filter users with the name "John"
    if(prop==="prodName") {
      const filterPD = prod.filter((pd) => pd.name === event.target.value);
      setProdImg(filterPD[0].img);
      // console.log(filterPD[0].img);
      await  setValuesf({ ...valuesf, prodName: filterPD[0].name  ,prodId: filterPD[0].id });
      
    } else {
      await  setValuesf({ ...valuesf, [prop]: event.target.value });
    }

    setDataChenged(true);
    setSaveSuccess(false);


  };

  //====================== end handle ============

  // console.log(valuesf);


  return (
    <div className="flex flex-col justify-center mx-auto pt-6 items-center w-full max-w-xl">
      {/* {!user.isLogin && navigate("/")} */}
      <div className="w-full">
        <Box className="flex p-1 justify-between ">
          <Typography variant="h6" component="h6" className="flex p-1 items-center" >
              Product Transaction
          </Typography>
          {user.user && user.user.isAdmin >=1 && 
                  <Typography variant="h6" component="h6" p={2} >
            <Link to="/products/stocks" className="p-1 border border-gray-500 rounded-md hover:text-sky-500">
              Back
            </Link>
          </Typography>
          }
        </Box>  
      </div>
      <div className="mt-2 px-4 flex items-center justify-end gap-x-3">
            {/* <UserCircleIcon aria-hidden="true" className="size-12 text-gray-300" /> */}
            <img 
              alt={prodImg || ''}
              className="object-cover h-28 w-48 border rounded"
              src={`${imgurl}/${prodImg}`}
            />  
      </div>

      <div className="m-auto mt-2 p-2 w-full justify-center items-center">
        <h2 className="text-base/7 font-semibold text-gray-300">Transaction Detail</h2>
          <div className="mt-2 grid grid-cols-1 md:grid-cols-2 md:gap-2 max-w-lg">
            <div className="col-span-1">
                <label htmlFor="date" className="block text-sm/6 font-medium text-gray-300">
                  Date
                </label>
                <div className="mt-2 grid grid-cols-1">
                  <input
                    id="date"
                    name="date"
                    value={valuesf.date}
                    disabled
                    onChange={handleFormChange('date')}
                    autoComplete="given-date"
                    type="datetime-local"
                    className="block sm:w-full rounded-md bg-slate-400 px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  />
                </div>
              </div>
            <div className="col-span-1">
              <label htmlFor="transType" className="block text-sm/6 font-medium text-gray-300">
                TransType
              </label>
              <div className="mt-2 grid grid-cols-1">
                <select
                  id="transType"
                  name="transType"
                  value={valuesf.transType}
                  onChange={handleFormChange('transType')}
                  autoComplete="transType"
                  className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {transType.map((t,i) => (
                   <option key={i}>{t.label}</option>
                  ))}
                </select>
                <ChevronDownIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                />
              </div>
            </div>
            <div className="col-span-1">
              <label htmlFor="prodName" className="block text-sm/6 font-medium text-gray-300">
                Name
              </label>
              <div className="mt-2 grid grid-cols-1">
                {/* <input
                  id="prodName"
                  name="prodName"
                  value={valuesf.prodName}
                  onChange={handleFormChange('prodName')}
                  autoComplete="given-prodName"
                  type="text"
                  className="block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                /> */}
                <select
                  id="prodName"
                  name="prodName"
                  value={valuesf.prodName}
                  onChange={handleFormChange('prodName')}
                  autoComplete="prodName"
                  className="col-start-1 row-start-1 sm:w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  <option key={0}></option>
                  {prod?.map((pd) => (
                   <option key={pd.id}>{pd.name}</option>
                  ))}
                </select>
                <ChevronDownIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                />
              </div>
            </div>

            
            <div className="col-span-1">
              <label htmlFor="qty" className="block text-sm/6 font-medium text-gray-300">
                QTY
              </label>
              <div className="mt-2 grid grid-cols-1">
                <input
                  id="qty"
                  name="qty"
                  value={valuesf.qty}
                  onChange={handleFormChange('qty')}
                  autoComplete="given-qty"
                  type="number"
                  className="block sm:w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                />
              </div>
            </div>




          </div>

          <div className="mt-6 flex items-center justify-between gap-x-6 border-t-2 py-2">
            <div>
              <button 
                  type="button" 
                  disabled={user.user?.isAdmin==1? false : true}
                  className={user.user?.isAdmin==1? "rounded-md bg-teal-800  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                  onClick={handleAddnew}
                  >
                  Add New
              </button>
            </div>
            <div className="flex gap-4">
              <button 
                type="button" 
                disabled={!dataChenged}
                className={dataChenged? "rounded-md bg-red-800  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : "rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                onClick={handleCancel}
                >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!dataChenged}
                className={dataChenged? "rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" :"rounded-md bg-slate-800 px-3 py-2 text-sm font-semibold"}
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
          {/* <MessInfo mess={errMsg} /> */}
          <p className={errMsg.type=='err'? "text-red-600" : "text-green-600"}>
            {errMsg.info}
          </p>
        </div>


      
    </div>

  )
}

export default StockTrans